import { observer } from 'mobx-react-lite'
import { Plural } from '@lingui/react/macro'

import type { UploadPhotoQueueStatusProps } from './UploadPhotoQueueStatus'

export const UploadPhotoQueueStatusUploadComplete =
  observer<UploadPhotoQueueStatusProps>(
    function UploadPhotoQueueStatusUploadComplete({ status }) {
      return status.isAlbumUpload ? (
        <Plural
          value={status.resolved}
          one="Done uploading file!"
          other="Done uploading # files!"
        />
      ) : (
        <Plural
          value={status.resolved}
          one="Done uploading # file! What do you want to do with it?"
          other="Done uploading # files! What do you want to do with them?"
        />
      )
    },
  )
